import { useNavigate } from 'react-router';

import { editProjectVenue } from '@/domain/project-venue/actions/edit-project-venue.action';
import { ProjectVenue } from '@/domain/project-venue/entities/project-venue.entity';
import {
  selectCurrentProjectVenue,
  selectIsEditingProjectVenue,
} from '@/domain/project-venue/project-venue.selectors';
import { PageTitle } from '@/ui/components/PageTitle';
import { useAppDispatch, useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';
import { EditProjectFormButtons } from '@/ui/pages/app/components/edit-project/EditProjectFormButtons';
import { EditProjectPaper } from '@/ui/pages/app/components/edit-project/EditProjectPaper';

import { ProjectVenueForm } from '../components/ProjectVenueForm';

export function EditProjectVenue() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const project = useAppSelector(selectCurrentProjectVenue);
  const isEditingProject = useAppSelector(selectIsEditingProjectVenue);

  const handleEditProject = async (data: ProjectVenue) => {
    try {
      const params = { project: data };
      await dispatch(editProjectVenue(params)).unwrap();
      navigate(`/app/projects/venue/${project?.id}`);
    } catch (error) {
      console.error(error);
    }
  };

  const handleBackButton = () => {
    navigate(`/app/projects/venue/${project?.id}`);
  };

  if (!project) {
    return null;
  }

  return (
    <>
      <PageTitle
        title={translate('ProjectsVenue.edit-season-page-title')}
        backButtonText={project?.name}
        onClickBack={handleBackButton}
      />
      <EditProjectPaper>
        <ProjectVenueForm
          project={project}
          onSubmit={handleEditProject}
          buttons={
            <EditProjectFormButtons isEditingProject={isEditingProject} />
          }
        />
      </EditProjectPaper>
    </>
  );
}
